import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    //首页
    path: '/',
    name: 'home',
    redirect: '/index',
    meta:{title:"我是首页"},

    component: () => import( '../views/index.vue'),
    children:[
      {
        path: '/index',
        name: 'Index',
        hidden: true,
        component: () => import('@/views/homes/home'),
      },
      {
        path: '/trends',
        name: 'trends',
        hidden: true,
        component: () => import('@/views/homes/trends'),

      },
      {
        path: '/EvaluationUnit',
        name: 'EvaluationUnit',
        hidden: true,
        component: () => import('@/views/homes/EvaluationUnit'),

      },
      {
        path: '/PingCeRenZheng',
        name: 'PingCeRenZheng',
        hidden: true,
        component: () => import('@/views/homes/PingCeRenZheng'),
      },
         {
        path: '/EvaluationHuiYuan',
        name: 'EvaluationHuiYuan',
        hidden: true,
        component: () => import('@/views/homes/EvaluationHuiYuan'),
      },
      {
        path: '/jianjie',
        name: 'jianjie',
        hidden: true,
        component: () => import('@/views/homes/jianjie'),
      },
      {
        path: '/SearchList',
        name: 'SearchList',
        hidden: true,
        component: () => import('@/views/homes/SearchList'),
      },
      {
        path: '/newslist',
        name: 'newslist',
        hidden: true,
        component: () => import('@/views/homes/NewsList'),
      },
      {
        path: '/NewsDetail',
        name: 'NewsDetail',
        hidden: true,
        component: () => import('@/views/homes/NewsDetail'),
      },

      {
        path: '/EvaluationUnitDeail',
        name: 'EvaluationUnitDeail',
        hidden: true,
        component: () => import('@/views/homes/EvaluationUnitDeail'),

      },
      {
        path: '/CertificateQuery',
        name: 'CertificateQuery',
        hidden: true,
        component: () => import('@/views/homes/CertificateQuery'),

      },
      {
        path: '/Memorabilia',
        name: 'Memorabilia',
        hidden: true,
        component: () => import('@/views/homes/Memorabilia'),

      },
      // CertificateQuery
    ]
  },
]

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location){
  return originalReplace.call(this,location).catch(err => err)
}

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to){
  return VueRouterPush.call(this,to).catch(err => err)
}

const router = new VueRouter({
  routes
})

export default router
